import axios from 'axios';

// Get user's current location
export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser.'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy
        });
      },
      (error) => {
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000 // 5 minutes
      }
    );
  });
};

// Get landmarks near user location
export const getLandmarks = async (params) => {
  try {
    const response = await axios.get('/api/suggestions/landmarks', {
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching landmarks:', error);
    throw error;
  }
};

// Get personalized ads
export const getPersonalizedAds = async (latitude, longitude) => {
  try {
    const response = await axios.get('/api/suggestions/ads', {
      params: { latitude, longitude }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching ads:', error);
    throw error;
  }
};

// Mark landmark as visited
export const markLandmarkVisited = async (landmarkId) => {
  try {
    const response = await axios.post(
      `/api/suggestions/visited/${landmarkId}`,
      {}
    );
    return response.data;
  } catch (error) {
    console.error('Error marking landmark as visited:', error);
    throw error;
  }
};

// Dismiss landmark suggestion
export const dismissLandmark = async (landmarkId) => {
  try {
    const response = await axios.post(
      `/api/suggestions/dismiss/${landmarkId}`,
      {}
    );
    return response.data;
  } catch (error) {
    console.error('Error dismissing landmark:', error);
    throw error;
  }
};
